<template>
  <main class="home">
    <WithdrawalUnavailable />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import WithdrawalUnavailable from "@/apps/credit-line/components/WithdrawalUnavailable.vue";

export default defineComponent({
  name: "WithdrawalUnavailableView",
  components: {
    WithdrawalUnavailable,
  },
  beforeMount() {
    setLanguage(this);
  },
  setup() {
    return {};
  },
});
</script>
